import React, { useMemo } from "react";
import { formatCurrency } from "../../utils/helpers";

const BAR_COLOR = "#3b6ea8";

/**
 * Horizontal bars for spend by service category (Report 2.0 layout).
 */
const Report20CategoryBarChart = ({ data = [] }) => {
  const chartData = useMemo(() => {
    const rows = (data || []).map((d) => ({
      category: d.category || "—",
      totalMRC: parseFloat(d.totalMRC) || 0,
      percentage: d.percentage,
    }));
    return [...rows].sort((a, b) => b.totalMRC - a.totalMRC);
  }, [data]);

  const maxVal = useMemo(
    () => chartData.reduce((m, r) => Math.max(m, r.totalMRC), 0) || 1,
    [chartData]
  );

  if (!chartData.length) {
    return (
      <p className="px-5 py-8 text-center text-[13px] text-[var(--muted,#6b6a66)]">
        No category data
      </p>
    );
  }

  return (
    <>
      <div className="px-5 pt-4 pb-3">
        <h3 className="text-[16px] font-semibold text-[var(--ink,#1c1c1a)]">
          Spend by service category
        </h3>
        <p className="mt-0.5 text-[12px] text-[var(--muted,#6b6a66)]">
          Total MRC per category
        </p>
      </div>
      <ul className="px-5 pb-4 space-y-3">
        {chartData.map((row) => {
          const pct = Math.min(100, Math.round((row.totalMRC / maxVal) * 100));
          const share =
            row.percentage != null && row.percentage !== ""
              ? Number(row.percentage).toFixed(1)
              : null;
          return (
            <li key={row.category} className="flex items-center gap-3">
              <div className="w-[7.5rem] shrink-0 text-[13px] font-medium text-[var(--ink,#1c1c1a)] truncate">
                {row.category}
              </div>
              <div className="flex-1 min-w-[80px] h-2.5 rounded-full bg-[var(--sunken,#eeece7)] overflow-hidden">
                <div
                  className="h-full rounded-full"
                  style={{ width: `${pct}%`, backgroundColor: BAR_COLOR }}
                />
              </div>
              <div className="w-[7.5rem] shrink-0 text-right">
                <p className="text-[13px] font-semibold tabular-nums text-[var(--ink,#1c1c1a)]">
                  {formatCurrency(row.totalMRC)}
                </p>
                {share != null ? (
                  <p className="text-[11px] tabular-nums text-[var(--muted,#6b6a66)]">
                    {share}% of total
                  </p>
                ) : null}
              </div>
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default Report20CategoryBarChart;
